(function () {

    'use strict';

    angular.module('iplusjs.footer', [
        'lodash',
        'iplusjs.config',
        'iplusjs.utils.misc',
        'iplusjs.utils.format'
    ])
        .component('iplusjsFooter', {
            templateUrl: 'common/footer/footer.html',
            bindings: {
                cssClassMainWidth: '@ifCssClassMainWidth',
                testsiegelFilterJsonPath: '<ifTestsiegelFilterJsonPath'
            },
            controller: FooterController,
            controllerAs: 'footerVm'
        });

    FooterController.$inject = [
        '$http',
        'lodash',
        'AppConfig',
        'MiscUtilsService',
        'FormatUtilsService'
    ];

    function FooterController($http, _, AppConfig, MiscUtilsService, FormatUtilsService) {
        var vm = this,
            testsiegelData;

        vm.$onInit = onInit;
        vm.$onChanges = onChanges;

        function onInit() {
            var serviceUrl;

            vm.testsiegelFilter = vm.testsiegelFilter || {};
            vm.ekomisiegelInfo = AppConfig.APP.urls.ekomisiegelInfo;
            vm.ekomisiegelUrl = null;

            if (MiscUtilsService.isNotEmpty(AppConfig.APP.urls.testsiegel)) {
                serviceUrl = '/' + AppConfig.APP.urls.testsiegel;

                $http.get(serviceUrl, {
                    unexpectedErrorsIgnore: true,
                    httpErrorsIgnore: true,
                    cache: true
                }).then(function (response) {
                    testsiegelData = response.data || [];
                    filterTestsiegelData();
                }).catch(function (error) {
                });
            }

            if (MiscUtilsService.isNotEmpty(vm.ekomisiegelInfo)) {
                $http.get(vm.ekomisiegelInfo, {
                    unexpectedErrorsIgnore: true,
                    httpErrorsIgnore: true,
                    cache: false
                }).then(function (response) {
                    var data = response.data || {},
                        feedbackAverage;

                    if (_.get(data, 'feedbacks', []).length > 0) {
                        feedbackAverage = parseFloat(_.get(data, 'info.fb_avg', 0));

                        if (feedbackAverage >= 4.8) {
                            vm.ekomisiegelUrl = _.get(AppConfig.APP.urls.ekomisiegel , 'gold');
                        } else if (feedbackAverage >= 4.4) {
                            vm.ekomisiegelUrl = _.get(AppConfig.APP.urls.ekomisiegel , 'silber');
                        } else {
                            vm.ekomisiegelUrl = _.get(AppConfig.APP.urls.ekomisiegel , 'bronze');
                        }
                    }
                }).catch(function (error) {
                    vm.ekomisiegelUrl = _.get(AppConfig.APP.urls.ekomisiegel , 'bronze');
                });
            }

            activate();
        }

        function onChanges(changes) {
            if (changes && changes.testsiegelFilterJsonPath) {
                if (!changes.testsiegelFilterJsonPath.isFirstChange()) {
                    filterTestsiegelData();
                }
            }
        }

        function activate() {
            vm.baseUrl = AppConfig.APP.urls.homepage;
        }

        function filterTestsiegelData() {
            var testsiegelFilterJsonPath = _.clone(vm.testsiegelFilterJsonPath),
                filter = _.clone(AppConfig.APP.testsiegelFilter);

            if (!filter) {
                return;
            }

            if (testsiegelFilterJsonPath) {
                filter = filter[testsiegelFilterJsonPath];
            }

            vm.testsiegel = _.get(_.filter(testsiegelData, filter)[0], 'Siegel');
        }
    }
})();
